import { useEffect, useState } from "react";
import { Building2, Bell, Gauge, Users, FileText, ClipboardList } from "lucide-react";
import AppLayout from "@/components/AppLayout";
import PageHeader from "@/components/PageHeader";
import KpiCard from "@/components/KpiCard";
import { LoadingState } from "@/components/LoadingState";
import { dashboardApi } from "@/api/endpoints";
import type { StaffDashboard } from "@/types";

export default function StaffDashboardPage() {
  const [data, setData] = useState<StaffDashboard | null>(null);
  useEffect(() => {
    dashboardApi.staff().then(setData);
  }, []);
  return (
    <AppLayout>
      <PageHeader title="System overview" subtitle="UmdoniWay platform statistics — click any card to drill in" />
      {!data ? (
        <LoadingState />
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <KpiCard label="Organisations" value={data.total_organisations} icon={<Building2 size={18} />} to="/staff/organisations" />
          <KpiCard label="Users" value={data.total_users} icon={<Users size={18} />} accent="blue" to="/staff/users" />
          <KpiCard label="Buildings" value={data.total_buildings} icon={<Building2 size={18} />} accent="slate" to="/staff/buildings" />
          <KpiCard label="Meters" value={data.total_meters} icon={<Gauge size={18} />} accent="slate" to="/staff/meters" />
          <KpiCard label="Readings" value={data.total_readings} icon={<FileText size={18} />} accent="blue" to="/staff/audit" />
          <KpiCard
            label="Unresolved alerts"
            value={data.unresolved_alerts}
            icon={<Bell size={18} />}
            accent={data.unresolved_alerts ? "red" : "brand"}
            to="/staff/alerts"
          />
          <KpiCard label="System audit log" value="View" icon={<ClipboardList size={18} />} accent="slate" to="/staff/audit" />
        </div>
      )}
    </AppLayout>
  );
}
